import React, { Component } from 'react'
import Activity from "framework/containers/Activity"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class RepresentativeFetchAttendanceActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/components/Hr/CommandFetchLog/CommandFetchLogBrowser")
	}

	render() {
		return (
			<Activity 
				name="RepresentativeFetchAttendance"
				RenderedComponent={this.RenderedComponent}
				context="RepresentativeFetchAttendance"
			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(RepresentativeFetchAttendanceActivity)
